import React from 'react';

import LandingNav from '../components/Landing/LandingNav';
import LandingBackground from '../components/Landing/LandingBackground';
import LandingHero from '../components/Landing/LandingHero';
import LandingFeatures from '../components/Landing/LandingFeatures';
import LandingDemo from '../components/Landing/LandingDemo';
import LandingPricing from '../components/Landing/LandingPricing';
// Gallery (LandingCommunity) and Testimonials are hidden for now — no real
// media to populate them yet. Re-mount once the user-generated grid and
// social proof copy are ready. Keep the imports out of the bundle so the
// hidden code doesn't ship.
// import LandingTestimonials from '../components/Landing/LandingTestimonials';
// import LandingCommunity from '../components/Landing/LandingCommunity';
import LandingFooter from '../components/Landing/LandingFooter';

// LiquidGlassFilter is mounted at the App root (App.jsx) so every page
// inherits it for free; no need to re-mount it here.

const LandingPage = () => {
    return (
        <div className="relative min-h-screen bg-[var(--bg-dark)] text-white">
            <LandingBackground />
            <LandingNav />
            <LandingHero />
            <LandingFeatures />
            <LandingDemo />
            <LandingPricing />
            {/* <LandingTestimonials /> hidden — see import comment */}
            {/* <LandingCommunity />   hidden — see import comment */}
            <LandingFooter />
        </div>
    );
};

export default LandingPage;
